module.exports = __webpack_public_path__ + "static/media/synth_04.1814e244.mp3";